import { Type } from '@sinclair/typebox';
import { createOperation, createOperationWithBody } from '../../routes/createOperation';
import { okResponse } from '../../routes/defaultResponses';
import { makeNullable } from '../../utils/typeboxHelpers';

export const userPaths = {
    '/api/user/otp/getQrCode': {
        get: {
            operationId: 'userControllers.getQrCodeForOtp',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                secret: Type.String(),
                                qrCodeDataUrl: Type.String(),
                            }),
                        },
                    },
                },
            },
        },
    },
    '/api/user/otp/secret': {
        post: {
            operationId: 'userControllers.setOtpSecret',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                isValid: Type.Boolean(),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            secret: Type.String(),
                            token: Type.String(),
                        }),
                    },
                },
            },
        },
    },
    '/api/user/otp': {
        delete: { operationId: 'userControllers.removeOtp', responses: { ...okResponse } },
    },
    '/api/user': {
        get: createOperation(
            'userControllers.getUser',
            [],
            Type.Object({ hasOtpEnabled: Type.Boolean(), enableOtpMessageFirstShownOn: makeNullable(Type.String()) }),
        ),
        post: createOperationWithBody(
            'userControllers.updateUser',
            [],
            Type.Object({ isSuccessful: Type.Boolean() }),
            Type.Object({
                enableOtpMessageFirstShownOn: makeNullable(Type.String()),
            }),
        ),
    },
} as const;
